const Divider = () => {
  return <div className='divider' />
}

export default Divider
